import { TextHighlight } from '@hendrx/icons/TextHighlight';
import { ColorPicker, Popover } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { RichTextEditor } from '@mantine/tiptap';
import { Editor } from '@tiptap/react';
import { useTranslation } from 'react-i18next';

import { HIGHLIGHT_COLORS } from './TextHighlightPicker.const';
import classes from './TextHighlightPicker.module.scss';

export type TextHighlightPickerProps = {
  editor: Editor | null;
};

export function TextHighlightPicker(props: TextHighlightPickerProps) {
  const { editor } = props;
  const currentColor = editor?.getAttributes('highlight')?.color;
  const { t } = useTranslation('widgets.textHighlightPicker');

  const [opened, { toggle, close }] = useDisclosure(false);

  const handleHighlightChange = (color: string) => {
    if (color === 'clear') {
      editor?.commands.unsetHighlight();
    } else {
      editor?.commands.setHighlight({ color });
    }

    close();
    editor?.commands.focus();
  };

  return (
    <Popover opened={opened} width={224} position="bottom" withArrow shadow="md" withinPortal={false}>
      <Popover.Target>
        <RichTextEditor.Control onClick={toggle} title={t('title')}>
          <TextHighlight />
        </RichTextEditor.Control>
      </Popover.Target>
      <Popover.Dropdown h={66} data-current-color={currentColor || undefined}>
        <ColorPicker
          size="sm"
          h={'100%'}
          swatches={HIGHLIGHT_COLORS}
          withPicker={false}
          onChange={handleHighlightChange}
          classNames={{
            swatch: classes.colorPickerSwatch
          }}
        />
      </Popover.Dropdown>
    </Popover>
  );
}
